import {Component} from 'react';
import h from 'react-hyperscript';
import BasicCard from 'Components/Cards/BasicCard';
// eslint-disable-next-line max-len
import SurveyMessaging from 'Pages/ReportCardOverview/SurveyReportStatus/SurveyMessaging/SurveyMessaging';
import SurveyStats from './SurveyStats/SurveyStats';

class ReportPendingState extends Component {
  render() {
    const props = this.props;

    const expirationDate = props.expirationDate;

    return h(
        BasicCard,
        {
          type: 'basic',
          className: 'report-overview__status status--no-report flex',
          id: `report-overview--${props.content.statusId}`,
        },
        h(
            'div',
            {
              className: 'flex--space-between flex--wrap',
            },
            [
              h(
                  SurveyMessaging,
                  {
                    borderRight: Boolean(expirationDate),
                    surveyTitle: props.surveyTitle,
                    title: props.content.title,
                    subtitle: props.content.subtitle,
                    statusId: props.content.statusId,
                    reportMissingDataNotFound: props.reportMissingDataNotFound,
                    reportMissingDataMsg: props.reportMissingDataMsg,
                    loading: props.reportLoading,
                    shareInfo: this.props.shareInfo,
                  },
                  null
              ),
          expirationDate ?
            h(
                SurveyStats,
                {
                  respondents: props.numRespondents,
                  expirationDate,
                  daysLeft: props.daysLeft,
                },
                null
            ) :
            null,
            ]
        )
    );
  }
}

export default ReportPendingState;
